// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer hr[data-v-22201586]{margin-top:24px;margin-bottom:24px}.footer p[data-v-22201586]{font-size:.75rem;--text-opacity:1;color:#666;color:rgba(102,102,102,var(--text-opacity))}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
